function MusteringPage () {
    return(
        <div>
            <p>Mustering</p>
        </div>
    )
}

export default MusteringPage;